module.exports = __webpack_public_path__ + "static/media/my-account-bg.4ca484e1.jpg";